import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Award, Target, Users, Leaf, Shield, TrendingUp } from 'lucide-react';
import { teamMembers } from '../mockData';

const About = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Hakkımızda</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            20 yılı aşkın sürede iklimlendirme sektöründe edinilen deneyim ve uzmanlık
          </p>
        </div>

        {/* Company Story */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img
              src="https://images.unsplash.com/photo-1761330439671-a7f20c285c5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21mb3J0YWJsZSUyMGxpdmluZyUyMHJvb20lMjBhaXIlMjBjb25kaXRpb25pbmd8ZW58MHx8fHwxNzYzMjA3NTM2fDA&ixlib=rb-4.1.0&q=85"
              alt="Koctech Klima"
              className="rounded-2xl shadow-2xl w-full h-96 object-cover"
            />
          </div>
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-gray-900">Hikayemiz</h2>
            <p className="text-gray-700 leading-relaxed">
              Koctech İklimlendirme, 20 yılı aşkın sürede iklimlendirme sektöründe hizmet veren, 
              müşteri memnuniyetini ön planda tutan bir firmadır. Kuruluşumuzdan bu yana binlerce 
              konut ve işyerine klima montajı, bakımı ve onarımı hizmeti verdik.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Deneyimli ekibimiz, modern teknolojileri takip ederek size en iyi hizmeti sunmayı 
              hedeflemektedir. Enerji verimliliği yüksek, çevre dostu çözümler sunarak hem 
              konforunuzu hem de doğayı düşünüyoruz.
            </p>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="grid md:grid-cols-2 gap-8 mb-20">
          <Card className="border-none shadow-lg hover:shadow-xl transition-all duration-300">
            <CardContent className="p-8">
              <Target className="w-12 h-12 text-teal-600 mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Misyonumuz</h3>
              <p className="text-gray-700 leading-relaxed">
                Müşterilerimize kaliteli, güvenilir ve enerji verimli iklimlendirme çözümleri sunarak 
                yaşam konforlarını artırmak. Uzman ekibimizle 7/24 hizmet vererek her zaman yanınızda olmak.
              </p>
            </CardContent>
          </Card>
          <Card className="border-none shadow-lg hover:shadow-xl transition-all duration-300">
            <CardContent className="p-8">
              <TrendingUp className="w-12 h-12 text-teal-600 mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Vizyonumuz</h3>
              <p className="text-gray-700 leading-relaxed">
                Türkiye'nin en güvenilir iklimlendirme firması olmak. Yenilikçi teknolojileri takip 
                ederek sektörde öncü konumda yer almak ve sürdürülebilir çözümlerle geleceğe katkı sağlamak.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Core Values */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Temel Değerlerimiz</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="border-none shadow-lg hover:shadow-xl transition-all duration-300 group hover:-translate-y-2">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Award className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kalite</h3>
                <p className="text-gray-600">
                  Her projede en yüksek kalite standartlarını uyguluyoruz
                </p>
              </CardContent>
            </Card>
            <Card className="border-none shadow-lg hover:shadow-xl transition-all duration-300 group hover:-translate-y-2">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Shield className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Güvenilirlik</h3>
                <p className="text-gray-600">
                  Müşterilerimize karşı her zaman dürüst ve güvenilir oluyoruz
                </p>
              </CardContent>
            </Card>
            <Card className="border-none shadow-lg hover:shadow-xl transition-all duration-300 group hover:-translate-y-2">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Leaf className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Çevre Bilinci</h3>
                <p className="text-gray-600">
                  Sürdürülebilir ve çevre dostu çözümler sunuyoruz
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Team */}
        <div>
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Ekibimiz</h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {teamMembers.map((member) => (
              <Card key={member.id} className="border-none shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="p-0">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-64 object-cover rounded-t-lg"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                    <p className="text-teal-600 font-semibold mb-2">{member.role}</p>
                    <p className="text-gray-600">{member.bio}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="mt-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-12">
          <div className="grid md:grid-cols-4 gap-8 text-center text-white">
            <div>
              <div className="text-5xl font-bold mb-2">2000+</div>
              <div className="text-teal-100">Mutlu Müşteri</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">20+</div>
              <div className="text-teal-100">Yıllık Deneyim</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">5000+</div>
              <div className="text-teal-100">Tamamlanan Proje</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">7/24</div>
              <div className="text-teal-100">Teknik Destek</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;